/**
 * Slug helpers shared by the page-editor components.
 *
 * Extracted (byte-identical behavior) from the duplicated copies that lived in
 * `PageSettingsPanel` and `QuickCreatePageDialog`.
 */

/** Generate a URL slug from a free-form title. */
export function generateSlug(title: string): string {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/** Sanitize a manually-typed slug value (lowercase, hyphen-only). */
export function sanitizeSlug(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9-]/g, '-')
}
